import FormControlLabel from "@mui/material/FormControlLabel";
import MuiSwitch, { SwitchProps as MuiSwitchProps } from "@mui/material/Switch";
import { Controller, UseControllerProps } from "react-hook-form";

export type SwitchProps = UseControllerProps<any> & {
  label: React.ReactNode;
} & MuiSwitchProps;

const SwitchToggle = (props: SwitchProps) => {
  const { control, name, label, sx, ...rest } = props;

  return (
    <Controller
      name={name}
      control={control}
      render={({ field }) => (
        <FormControlLabel
          control={
            <MuiSwitch
              checked={field.value}
              sx={{
                backgroundColor: "none",
                background: "none",
                ...sx,
              }}
              {...field}
              {...rest}
            />
          }
          sx={{
            flexDirection: "row-reverse",
            justifyContent: "space-between",
            width: "100%",
            margin: 0,
          }}
          label={label}
        />
      )}
    />
  );
};

export default SwitchToggle;
